import React from 'react';
import styles from './TransportsExpandedRow.module.scss';
import TransportDocuments from '../../../../../../components/TransportDocuments/TransportDocuments';
import PermitsByTransport from '../PermitsByTransport/PermitsByTransport';

const TransportsExpandedRow = ({ record = {} }) => {
  const { transport } = record;

  return (
    <div className={styles.root}>
      <div className={styles.firstCol}>
        <TransportDocuments transportId={transport?.id} />
      </div>
      <PermitsByTransport transportId={transport?.id} />
    </div>
  );
};

export default TransportsExpandedRow;
